import {findIndex} from 'lodash';
import {VFUser} from 'types/api/api-models';
import UserManagementContextPropsType from './ManagementContextPropTypes';

export const actions = {
  ROUTING_PROFILES_LOADED: 'ROUTING_PROFILES_LOADED',
  SET_ROUTING_PROFILES: 'SET_ROUTING_PROFILES',
  SECURITY_PROFILES_LOADED: 'SECURITY_PROFILES_LOADED',
  SET_SECURITY_PROFILES: 'SET_SECURITY_PROFILES',
  USER_HIERARCHIES_LOADED: 'USER_HIERARCHIES_LOADED',
  SET_USER_HIERARCHIES: 'SET_USER_HIERARCHIES',
  CONNECT_USERS_LOADED: 'CONNECT_USERS_LOADED',
  SET_CONNECT_USERS: 'SET_CONNECT_USERS',
  UPDATE_USER_ROUTING_PROFILE: 'UPDATE_USER_ROUTING_PROFILE',
};

export function reducer(
  state: any,
  action: any,
): UserManagementContextPropsType {
  switch (action.type) {
    case actions.ROUTING_PROFILES_LOADED:
      return {
        ...state,
        routingProfilesLoaded: true,
      };
    case actions.SET_ROUTING_PROFILES:
      return {
        ...state,
        routingProfiles: action.payload,
        routingProfileDict: action.payload.reduce(
          (acc, rp) => ({
            ...acc,
            [rp.Id]: rp,
          }),
          {},
        ),
      };
    case actions.SECURITY_PROFILES_LOADED:
      return {
        ...state,
        securityProfilesLoaded: true,
      };
    case actions.SET_SECURITY_PROFILES:
      return {
        ...state,
        securityProfiles: action.payload,
        securityProfileDict: action.payload.reduce(
          (acc, rp) => ({
            ...acc,
            [rp.Id]: rp,
          }),
          {},
        ),
      };
    case actions.USER_HIERARCHIES_LOADED:
      return {
        ...state,
        userHierarchiesLoaded: true,
      };
    case actions.SET_USER_HIERARCHIES:
      return {
        ...state,
        userHierarchies: action.payload,
        userHierarchyDict: action.payload.reduce(
          (acc, rp) => ({
            ...acc,
            [rp.Id]: rp,
          }),
          {},
        ),
      };
    case actions.CONNECT_USERS_LOADED:
      return {
        ...state,
        connectUsersLoaded: true,
      };
    case actions.SET_CONNECT_USERS:
      return {
        ...state,
        connectUsers: action.payload,
      };
    case actions.UPDATE_USER_ROUTING_PROFILE:
      const users: VFUser[] = state.connectUsers.slice();
      const idx = findIndex(users, (user) => user.Id === action.payload.userId);
      let user = state.connectUsers[idx];
      user = {
        ...user,
        RoutingProfileId: action.payload.routingProfileId,
      };
      users.splice(idx, 1, user);
      return {
        ...state,
        connectUsers: users,
      };
    default:
      return state;
  }
}
